import { PropsOf } from 'utils/reactHelpers';
import { DynamicContentBuilder } from 'modules/dynamicContentBuilder';
import { ContentType, InsertFn } from 'modules/dynamicContentBuilder/types';

import { ModalType, useModalContext } from '../context';

export const useDynamicContentBuilder = (insert: InsertFn) => {
  const { openModal, closeModal } = useModalContext();

  const onClose = () => closeModal(ModalType.DynamicContentBuilder);

  const onInsert = (content: string) => {
    onClose();
    insert(content);
  };

  const dynamicContentBuilderProps: PropsOf<typeof DynamicContentBuilder> = {
    onClose,
    onInsert,
    contentType: ContentType.plaintext,
  };

  const show = () => openModal(ModalType.DynamicContentBuilder, dynamicContentBuilderProps);

  return {
    show,
  };
};
